import { render } from "./currentAddress.vue?vue&type=template&id=ade53b42&scoped=true"
import script from "./currentAddress.vue?vue&type=script&lang=js"
export * from "./currentAddress.vue?vue&type=script&lang=js"

import "./currentAddress.vue?vue&type=style&index=0&id=ade53b42&scoped=true&lang=css"

import exportComponent from "/usr/share/nginx/elsaygh_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ade53b42"]])

export default __exports__